import { FetchModels, SelectedPhoto } from 'features/reviews';
import { Reducers } from '../state';

export const mapFromStateToPostData = (
  formState: Reducers.FormState,
  productId: string,
): FetchModels.PostReviewData => {
  const authorDetails = [];
  if (formState.authorTimeUsage !== null) {
    authorDetails.push({
      name: 'time_usage',
      value: formState.authorTimeUsage.value,
      label: formState.authorTimeUsage.label ?? 'Срок использования',
    });
  }
  if (formState.authorShop !== null) {
    authorDetails.push({
      name: 'shop',
      value: formState.authorShop,
      label: 'Магазин',
    });
  }

  return {
    rating: formState.totalScore ?? 0,
    body: formState.bodyText ?? '',
    pros: formState.prosText ?? undefined,
    cons: formState.consText ?? undefined,
    author_details: authorDetails,
    author_name: formState.authorName ?? '',
    author_email: formState.authorEmail ?? '',
    product_id: productId,
    photo_ids: [],
  };
};

export const uploadTokenSelector = (selectedPictures: SelectedPhoto[]) => (src: string) => {
  return selectedPictures.find((r) => r.coverSrc === src)?.uploadToken ?? null;
};
